export default __webpack_public_path__ + "static/media/img (3).d9e10cc0.jpg";